import React from 'react';
import PageLayout from '../../ui/layout/PageLayout';
import VideosList from './components/VideosList';
import useVideosDomain from './hooks/useVideosDomain';
import './styles.css';

function VideosPage() {
  const state = useVideosDomain();

  return (
    <PageLayout
      title="Vídeos"
      subtitle="Biblioteca e monitoramento de geração"
      primary={<VideosList state={state} />}
      secondary={null}
    />
  );
}

export default VideosPage;
